export default {
    LOGIN: 'login',
    DIALOG: 'dialog',
    SETTINGS: 'settings',
    WORKBENCH: 'workbench',
    OAUTH: 'oauth',
};
